/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_M2Inputs */

const cs_enum_m2 = /** @type {(inputs: Enum_M2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m²`)
};

const en_enum_m2 = /** @type {(inputs: Enum_M2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`m²`)
};

/**
* | output |
* | --- |
* | "m²" |
*
* @param {Enum_M2Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_m2 = /** @type {((inputs?: Enum_M2Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_M2Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_m2(inputs)
	return cs_enum_m2(inputs)
});